// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"8109e023","258":"64633967","496":"66541e1d","551":"3db76079","578":"a9d7c9bb","590":"dbf53bea","986":"f749bafd"}[chunkId] + ".chunk.js";
};